import { Card, Rate, Switch, message } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { authRequest } from '../../../../../../common/request/authRequest';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { InfoCircleOutlined, LockFilled } from '@ant-design/icons';
import { GlobalVariableContext } from '../../../../../../store/GlobalVariableContext/GlobalVariableContext';

const cardStyle = {
	background: '#fff',
	margin: 0,
	marginLeft: 0,
	width: '100%',
	borderRadius: 10,
	border: '1px solid rgba(148, 163, 184, 0.28)',
};

const SCORES = [1, 2, 3, 4, 5];

export const AutomateReviewsTab = (props: { openDrawer: boolean, setOpenDrawer: any, locationId?: string }) => {

	const [updateData, setUpdateData] = useState(false);
	const [rules, setRules] = useState<any>(null);
	const { profile, projectGroup } = useAuth();
	const locationIdPath = props.locationId ? '/locations/' + props.locationId : '';
	const { updateGlobalData, setUpdateGlobalData } = useContext(GlobalVariableContext);

	const hasAutomatedRole = profile.roles.includes('ROLE_AUTOMATED_ADMIN') || profile.roles.includes('ROLE_AUTOMATED_REVIEWS');

	useEffect(() => {
		authRequest(`${process.env.REACT_APP_API}/automated/reviews/${projectGroup.group}${locationIdPath}`, {})
			.then((response) => {
				setRules(response);
			}).catch(() => { message.error('Error al cargar reglas'); });
	}, [updateData]);

	const changeStatus = async (score: number, hasText: boolean, automated: boolean) => {
		const data = {
			project: projectGroup.project,
			hasText: hasText,
			score: score,
			automated: automated
		};

		await authRequest(`${process.env.REACT_APP_API}/automated/reviews/${projectGroup.group}${locationIdPath}`, { method: 'PATCH', data: data })
			.then(() => {
				setUpdateData(!updateData);
				setUpdateGlobalData(!updateGlobalData);
				message.success('Cambio correcto');
			}).catch(() => {
				message.error('Error imprevisto');
			});
	};

	if (!rules) {
		return null;
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
			{!hasAutomatedRole && (
				<div style={{
					display: 'flex',
					alignItems: 'center',
					gap: 8,
					padding: '10px 12px',
					borderRadius: 8,
					background: '#faf5ff',
					border: '1px solid #e9d5ff',
					color: '#7e22ce',
					fontSize: 13,
					fontWeight: 600,
				}}>
					<LockFilled />
					Tu plan no te permite automatizar
				</div>
			)}

			<section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
				<Card
					className='card-layout'
					bodyStyle={{ padding: '14px 16px' }}
					style={cardStyle}
				>
					<div style={{
						display: 'flex',
						alignItems: 'flex-start',
						gap: 8,
						padding: '10px 12px',
						marginBottom: 14,
						borderRadius: 8,
						background: '#f8fafc',
						border: '1px solid rgba(148, 163, 184, 0.22)',
					}}>
						<InfoCircleOutlined style={{ color: 'teal', marginTop: 2, flexShrink: 0 }} />
						<small style={{ color: '#64748b', lineHeight: 1.45 }}>
							Activa la respuesta automática según la puntuación de la reseña y si incluye texto o no
						</small>
					</div>

					<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
						{SCORES.map((score) => (
							<div
								key={score}
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 14,
									padding: '12px 14px',
									borderRadius: 8,
									border: '1px solid rgba(148, 163, 184, 0.22)',
									background: '#fff',
								}}
							>
								<div style={{
									minWidth: 110,
									display: 'flex',
									flexDirection: 'column',
									gap: 4,
								}}>
									<div style={{
										fontSize: 13,
										fontWeight: 600,
										color: '#0f172a',
										lineHeight: 1.3,
									}}>
										{score} {score === 1 ? 'estrella' : 'estrellas'}
									</div>
									<Rate
										className="automate-reviews-rate"
										disabled
										value={score}
										style={{ fontSize: 14, color: '#475569' }}
									/>
								</div>

								<div style={{
									flex: 1,
									display: 'grid',
									gridTemplateColumns: '1fr 1fr',
									gap: 10,
								}}>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										gap: 8,
										padding: '10px 12px',
										borderRadius: 8,
										background: '#f8fafc',
										border: '1px solid rgba(148, 163, 184, 0.18)',
									}}>
										<div style={{ minWidth: 0 }}>
											<div style={{
												fontSize: 13,
												fontWeight: 600,
												color: '#64748b',
												lineHeight: 1.3,
											}}>
												Sin texto
											</div>
										</div>
										<Switch
											className="automate-labels-switch"
											disabled={!hasAutomatedRole}
											style={{ minWidth: 120 }}
											checkedChildren='Automatizado'
											unCheckedChildren='Manual'
											checked={!!rules[`${score}_false`]?.automated}
											onClick={(checked) => { changeStatus(score, false, checked); }}
										/>
									</div>

									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										gap: 8,
										padding: '10px 12px',
										borderRadius: 8,
										background: '#f8fafc',
										border: '1px solid rgba(148, 163, 184, 0.18)',
									}}>
										<div style={{ minWidth: 0 }}>
											<div style={{
												fontSize: 13,
												fontWeight: 600,
												color: '#64748b',
												lineHeight: 1.3,
											}}>
												Con texto
											</div>
										</div>
										<Switch
											className="automate-labels-switch"
											disabled={!hasAutomatedRole}
											style={{ minWidth: 120 }}
											checkedChildren='Automatizado'
											unCheckedChildren='Manual'
											checked={!!rules[`${score}_true`]?.automated}
											onClick={(checked) => { changeStatus(score, true, checked); }}
										/>
									</div>
								</div>
							</div>
						))}
					</div>
				</Card>
			</section>

			<style>{`
				.ant-switch.automate-labels-switch.ant-switch-checked {
					background-color: #389e0d !important;
				}
				.automate-reviews-rate .ant-rate-star-first,
				.automate-reviews-rate .ant-rate-star-second {
					color: #d4d4d8;
				}
				.automate-reviews-rate .ant-rate-star-full .ant-rate-star-second,
				.automate-reviews-rate .ant-rate-star-half .ant-rate-star-first {
					color: inherit;
				}
			`}</style>
		</div>
	);
};
